import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applications: [],
  currentApplication: null,
  isLoading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  filters: {
    status: '',
    district: '',
    dateRange: {
      start: null,
      end: null,
    },
    search: '',
  },
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    // Fetch applications
    fetchApplicationsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchApplicationsSuccess: (state, action) => {
      state.isLoading = false;
      state.applications = action.payload.applications;
      state.pagination = action.payload.pagination;
    },
    fetchApplicationsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Fetch single application
    fetchApplicationStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchApplicationSuccess: (state, action) => {
      state.isLoading = false;
      state.currentApplication = action.payload;
    },
    fetchApplicationFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Create application
    createApplicationStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    createApplicationSuccess: (state, action) => {
      state.isLoading = false;
      state.applications.unshift(action.payload);
    },
    createApplicationFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Update application
    updateApplicationStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    updateApplicationSuccess: (state, action) => {
      state.isLoading = false;
      const index = state.applications.findIndex(app => app.id === action.payload.id);
      if (index !== -1) {
        state.applications[index] = action.payload;
      }
      if (state.currentApplication && state.currentApplication.id === action.payload.id) {
        state.currentApplication = action.payload;
      }
    },
    updateApplicationFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Set filters
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    // Set pagination
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },

    // Clear current application
    clearCurrentApplication: (state) => {
      state.currentApplication = null;
    },

    // Clear all
    clearAllApplications: (state) => {
      state.applications = [];
      state.currentApplication = null;
      state.isLoading = false;
      state.error = null;
      state.pagination = initialState.pagination;
      state.filters = initialState.filters;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchApplicationsStart,
  fetchApplicationsSuccess,
  fetchApplicationsFailure,
  fetchApplicationStart,
  fetchApplicationSuccess,
  fetchApplicationFailure,
  createApplicationStart,
  createApplicationSuccess,
  createApplicationFailure,
  updateApplicationStart,
  updateApplicationSuccess,
  updateApplicationFailure,
  setFilters,
  setPagination,
  clearCurrentApplication,
  clearAllApplications,
  clearError,
} = applicationSlice.actions;

export default applicationSlice.reducer;
